import { Component, Inject, OnInit } from '@angular/core';
import { BCI_WK_MODAL_DATA, BciWkModalService } from '@bci/webkitbci';

@Component({
  selector: 'app-modal-redirect',
  templateUrl: './modal-redirect.component.html',
  styleUrls: ['./modal-redirect.component.scss'],
  standalone: false
})
export class ModalRedirectComponent implements OnInit {
  constructor(
    private modal: BciWkModalService,
    @Inject(BCI_WK_MODAL_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.modal.setStyles({
      containerStyle: {
        padding: '32px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        width: '600px',
        overflowY: 'hidden',
      },
    });
  }

  close() {
    this.modal.close();
  }

  goToRedirect() {
    window.parent.location.href = this.data.submotivo.url;
  }

  goToSchedule() {
    this.data.fnAgendar();
    this.modal.close();
  }
}
